import {Component, computed, effect, inject, signal} from '@angular/core';
import {Router, RouterLink} from "@angular/router";
import {toSignal} from "@angular/core/rxjs-interop";
import {BsTheme} from "../../models/bs-theme.model";
import {BsThemeService} from "../../service/bs-theme.service";
import {NgOptimizedImage} from "@angular/common";
import {BsMenuComponent} from "../bs-menu/bs-menu.component";
import {SideNavigationService, SideNavigationState} from "../../service/side-navigation.service";
import {Button} from "primeng/button";
import {BsSideNavigationMenuComponent} from "../bs-side-navigation-menu/bs-side-navigation-menu.component";
import {BsSwLogoComponent} from "../../icons/bs-sw-logo.component";

@Component({
  selector: 'bs-side-navigation',
  imports: [
    NgOptimizedImage,
    RouterLink,
    BsMenuComponent,
    Button,
    BsSideNavigationMenuComponent,
    BsSwLogoComponent
  ],
  templateUrl: './bs-side-navigation.component.html',
  styleUrl: './bs-side-navigation.component.css',
  standalone: true
})
export class BsSideNavigationComponent {
  router = inject(Router);
  themeService = inject(BsThemeService);
  sideNavigationService = inject(SideNavigationService);
  sideNavWidth = '60px';

  theme = toSignal(this.themeService.theme$);
  darkModeChecked = computed(() => {
    return this.theme() === BsTheme.DARK;
  });
  sideNavigationState = toSignal(this.sideNavigationService.sideNavigationState$)

  constructor() {
    effect(() => {
      if (this.sideNavigationState() === SideNavigationState.HalfClosed){
        this.halfCloseNav();
      } else {
        this.hideNav();
      }
    });
  }

  halfCloseNav(){
    (document as any).getElementById("mySidenav").style.width = this.sideNavWidth;
    (document as any).getElementById("main").style.marginLeft= this.sideNavWidth;
  }

  hideNav() {
    (document as any).getElementById("mySidenav").style.width = "0";
    (document as any).getElementById("main").style.marginLeft= "0";
  }
}
